const groupsLoadedReducer = (state, action) => {
  return {
    ...state,
    groupsLoaded: false,
    selectedGroupSetId: action.id,
  };
};

export default groupsLoadedReducer;
